export default __webpack_public_path__ + "static/media/payroll-feature-pension-remittance.6a10796b.svg";